import React from 'react';
import { Link } from 'react-router';
import Seo from "./Seo"

class Error extends React.Component {
	render() {
		return (
			<div>
				<Seo title="Error - your content could not be found" />

				<div className="error-wrapper">
					<h1 className="main-title">Error</h1>
					<p>Sorry, there's been an error. You can <Link className="inline" to="/route-planning">plan a route</Link> or <Link className="inline" to="/leisure-rides">browse leisure rides</Link>.</p>
				</div>
			</div>
		)
	}
}

export default Error;



// WEBPACK FOOTER //
// ./src/components/Error.js